/* Victoria Rockera — Drawer lateral de filtros + load infinito. */
(function () {
  'use strict';

  // ---------------- Load infinito ----------------
  function initInfinite() {
    var sentinel = document.querySelector('[data-vr-load-more]');
    if (!sentinel || !('IntersectionObserver' in window)) return;

    var grid = document.querySelector('[data-vr-grid]');
    if (!grid) return;

    var loading = false;

    function getNextUrl() {
      return sentinel.getAttribute('data-next-url');
    }

    function loadMore() {
      var nextUrl = getNextUrl();
      if (!nextUrl || loading) return;
      loading = true;
      sentinel.classList.add('is-loading');

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-vr-grid]');
          if (newGrid) {
            // Mover hijos uno a uno (preserva listeners y aplica fade-in)
            var children = Array.from(newGrid.children);
            children.forEach(function (el) {
              el.classList.add('vr-fade-in');
              grid.appendChild(el);
            });
          }
          var newSentinel = doc.querySelector('[data-vr-load-more]');
          if (newSentinel) {
            sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
          } else {
            // No hay más páginas: quitar el sentinel y desconectar observer
            observer.unobserve(sentinel);
            sentinel.remove();
          }
          loading = false;
          sentinel.classList.remove('is-loading');
        })
        .catch(function () {
          loading = false;
          sentinel.classList.remove('is-loading');
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadMore();
        }
      });
    }, { rootMargin: '600px 0px' });

    observer.observe(sentinel);
  }

  // ---------------- Drawer filtros ----------------
  function init() {
    var openBtn = document.querySelector('[data-vr-filter-open]');
    var dialog = document.querySelector('[data-vr-filter-drawer]');
    var closeBtn = document.querySelector('[data-vr-filter-close]');

    initInfinite();

    if (!openBtn || !dialog) return;

    function open() {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('vr-no-scroll');
    }

    function close() {
      if (typeof dialog.close === 'function') {
        try { dialog.close(); } catch (e) { dialog.removeAttribute('open'); }
      } else {
        dialog.removeAttribute('open');
      }
      document.documentElement.classList.remove('vr-no-scroll');
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Cerrar al hacer click fuera del contenido
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    // Cerrar con escape
    dialog.addEventListener('cancel', function () {
      document.documentElement.classList.remove('vr-no-scroll');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
